import { helpers } from '@vuelidate/validators';

/**
 * 数値のみを許可するバリデーター
 */
export const numeric = helpers.regex(/^\d+$/);

/**
 * 「その他」が選択されている場合、対応するテキストフィールドが必須
 * @param {string} value - テキストフィールドの値
 * @param {object} siblings - フォームの他のフィールド
 * @param {string} fieldName - チェック対象のフィールド名
 */
export const requiredIfOther = (value, siblings, fieldName) => {
  const selectedValue = siblings[fieldName];

  // 単一選択の場合
  if (typeof selectedValue === 'string' && selectedValue === 'その他') {
    return value && value.trim().length > 0;
  }

  // 複数選択の場合
  if (Array.isArray(selectedValue) && selectedValue.includes('その他')) {
    return value && value.trim().length > 0;
  }

  // 「その他」が選択されていない場合は常にvalid
  return true;
};

/**
 * Q3の「その他」フィールド専用バリデーター（旧Q1: 100万円の使い道）
 */
export const requiredIfQ3Other = helpers.withParams(
  { type: 'requiredIfOther' },
  (value, siblings) => requiredIfOther(value, siblings.questions, 'q3'),
);

/**
 * Q6の「その他」フィールド専用バリデーター（旧Q5: 視聴きっかけ）
 */
export const requiredIfQ6Other = helpers.withParams(
  { type: 'requiredIfOther' },
  (value, siblings) => requiredIfOther(value, siblings.questions, 'q6'),
);

/**
 * Q8の「その他」フィールド専用バリデーター（旧Q7: 実践したいこと）
 */
export const requiredIfQ8Other = helpers.withParams(
  { type: 'requiredIfOther' },
  (value, siblings) => requiredIfOther(value, siblings.questions, 'q8'),
);
